import { Door, Query } from 'graphql/generated/graphqlTypes';
import { mockDoors } from 'mocks/graphqlMocks/doorFixtures';

export function mockedGetDoorsForTenantData(getDoorsForTenant: Array<Door>): Pick<Query, 'getDoorsForTenant'> {
  return {
    getDoorsForTenant
  };
}

export const mockedGetDoorsForTenantDataForQuery = mockedGetDoorsForTenantData(mockDoors);

export const mockedGetDoorsForTenantDataAdmin = mockedGetDoorsForTenantDataForQuery;
